import { fechaDelTurno } from './separadoresDeDia';

/**
 * Con qué parte del hilo abre el copiloto.
 *
 * La conversación es UNA por usuario: lo que se abre puede tener semanas y varias
 * obras adentro. Abrir en medio de lo que se habló de otra obra la semana pasada es
 * abrir en medio de otra charla, así que a la vista quedan los turnos de las últimas
 * 24 horas de la obra abierta y el resto espera detrás de un botón.
 *
 * Los turnos viejos no tienen obra —se guardaron antes de que el mensaje se acordara
 * de cuál era— y nunca la van a tener: a esos los tapa la ventana de 24 horas, no la
 * obra. Por eso no se tiran: quedan atrás del botón, no afuera.
 *
 * Un turno sin fecha se toma como del momento: los arma el panel al hablar. Esconder
 * un turno que no se puede ubicar en el tiempo es peor que mostrarlo de más.
 */

const VENTANA_MS = 24 * 60 * 60 * 1000;

function esDeLaObra(turno, obra) {
  return !turno.obra || turno.obra === obra;
}

function esReciente(turno, ahora, ventanaMs) {
  const fecha = fechaDelTurno(turno.fecha);
  if (!fecha) return true;
  return ahora.getTime() - fecha.getTime() < ventanaMs;
}

/**
 * Parte el hilo en lo que se ve y lo que espera. Devuelve `{ visibles, ocultos }`,
 * donde `ocultos` es cuántos turnos quedaron atrás del botón.
 */
export function plegarHilo(turnos, {
  obra = null,
  ahora = new Date(),
  desplegado = false,
  ventanaMs = VENTANA_MS,
} = {}) {
  const lista = Array.isArray(turnos) ? turnos : [];
  if (desplegado) return { visibles: lista, ocultos: 0 };
  const visibles = lista.filter((t) => esDeLaObra(t, obra) && esReciente(t, ahora, ventanaMs));
  return { visibles, ocultos: lista.length - visibles.length };
}
